import { render } from "./colorpicker.vue?vue&type=template&id=069fdd28&scoped=true&ts=true"
import script from "./colorpicker.vue?vue&type=script&lang=ts"
export * from "./colorpicker.vue?vue&type=script&lang=ts"

import "./colorpicker.vue?vue&type=style&index=0&id=069fdd28&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-069fdd28"]])

export default __exports__